import dicomLogo from '../../../images/dicom-plugin-logo.png';
import thankYouIcon from '../../../images/check.png';

export default function RecorbDownloadResult() {
  return (
    <div className='flex flex-col justify-center items-center mx-auto w-full'>
      <div className='max-w-[920px] '>
        <div className='m-auto mb-5 w-fit'>
          <img src={dicomLogo} alt='Dicom Plugin Logo' className='w-[179px]' />
        </div>
      </div>
      <div className='w-full mx-[52px] h-[128px] border-[#287D3C] gap-4 border bg-[#F4FBF6] flex px-5 py-4 rounded-xl'>
        <div className=''>
          <img src={thankYouIcon} alt='Thank you icon' />
        </div>
        <div className='flex flex-col'>
          <span className='text-[#098906] font-bold mb-2'>Thank you for your purchase.</span>
          <p className='text-[#333333] mb-1'>
            We have received your purchase information. A confirmation email has been sent to the
            email address you registered. Please check your email.
          </p>
          <p className='text-[#333333]'>
            If you have any questions or concerns, please feel free to contact us.
          </p>
        </div>
      </div>
    </div>
  );
}
